import fetchRequest from '@/app/_utils/fetch-request'
import { isNotFoundFetchError, reportFetchError } from '@/app/_utils/handle-fetch-error'

export async function getPDPData(slug: string, isServerSideRequest = false) {
    const endpoint = `/products/slug/${slug}`

    try {
        const result = await fetchRequest({
            endpoint,
            serviceName: 'ntl',
            isServerSideRequest,
            openAuthModal: false,
        })

        return result
    } catch (error) {
        if (isNotFoundFetchError(error)) return null

        throw reportFetchError('error-fetching-pdp-data', `Endpoint: ${endpoint}`, error)
    }
}
